export const environment = {
    production: false,
    VERSION: 'dev-preview',
    base_url: 'preview.4allweb.de'
  };
